import { Student, db } from "../../mp-database"
import { fetchCreators } from "./fetchCreators"

export const fetchStudents = async (
  districtId: string,
  schoolId: string,
  teacherId?: string,
  classId?: string,
  isDeleted?: boolean
): Promise<Student[]> => {
  let queryRef = db
    .collection("students")
    .where("schoolDistrict", "==", districtId)

  if (schoolId) {
    queryRef = queryRef.where("school", "==", schoolId)
  }

  if (teacherId) {
    queryRef = queryRef.where(`teachers.${teacherId}`, "==", true)
  }

  if (isDeleted !== undefined) {
    queryRef = queryRef.where("deleted", "==", isDeleted)
  }

  let students = (await queryRef.get()).docs.map(item => item.data() as Student)

  if (classId && !!students?.length) {
    const selectedClass = (
      await db.collection("classes").doc(classId).get()
    ).data()

    if (!!selectedClass) {
      students = students.filter(
        student => selectedClass?.students?.[student.id]
      )

      if (isDeleted !== undefined) {
        students = students.filter(student => student.deleted === isDeleted)
      }
    }
  }

  return fetchCreators<Student>(students)
}
